module.exports = __webpack_public_path__ + "858f31e7fc6ab829b1d7d4d0d4e4ad86.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/dreidel.png
// module id = 2998
// module chunks = 0